var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRedeemShirtIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.646484,
    width: 40,
    height: 40,
    rx: 12,
    fill: "#E2FAF8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5914_42650)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.7 12.6465H23.5C23.5 14.3465 22.1 15.6465 20.5 15.6465C18.9 15.6465 17.5 14.3465 17.5 12.6465H15.3L12.5 14.0465V18.6465C12.5 19.2465 12.9 19.6465 13.5 19.6465H15.5V27.6465C15.5 28.2465 15.9 28.6465 16.5 28.6465H24.5C25.1 28.6465 25.5 28.2465 25.5 27.6465V19.6465H27.5C28.1 19.6465 28.5 19.2465 28.5 18.6465V14.0465L25.7 12.6465Z",
    fill: "#49DED5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5914_42650"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(12.5 12.6465)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedeemShirtIcon);
export default __webpack_public_path__ + "static/media/redeem-shirt-icon.1f97b131e6034fc772791d4a089edfff.svg";
export { ForwardRef as ReactComponent };